<div class="pull-right text-muted">
  <a ng-click="tarefa.showHistory()">
    <i class="icon-updated" aria-hidden="true"></i> Histórico
  </a>
</div>
<div class="clearfix"></div>

<div class="title text-center">
  <h2>
    <strong>NOVA TAREFA</strong>
  </h2>
</div>

<form id="tarefa_form" name="tarefa_form" class="tarefa no-padding" novalidate ng-submit="tarefa.save(tarefa_form)">

  <div class="form-group"><!-- glebas -->
    <ui-select multiple ng-model="tarefa.task.glebas" ng-change="tarefa.changeGlebasSelected()" theme="bootstrap" id="glebas" name="glebas">
      <ui-select-match allow-clear="true" placeholder="Filtre os Talhões...">{{$item.descricao | humanize}} ({{$item.area_total | number:0}} ha)</ui-select-match>
      <ui-select-choices repeat="gleba in $root.currentPropriedade.glebas | orderBy: 'descricao' | filter: $select.search">
        <span ng-bind-html="gleba.descricao | humanize | highlight: $select.search"></span> ({{gleba.area_total | number:0}} ha)
      </ui-select-choices>
    </ui-select>
  </div>

  <div class="form-group" ng-class="{'has-error': tarefa_form.safra.$invalid}"><!-- safra -->
    <ui-select ng-model="tarefa.task.safra" theme="bootstrap" id="safra" name="safra" required>
      <ui-select-match allow-clear="true" placeholder="Safra">{{$select.selected.descricao}}</ui-select-match>
      <ui-select-choices repeat="safra in $root.safras | orderBy: '-descricao' | filter: $select.search">
        <span class="form-group" ng-bind-html="safra.descricao | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
    <p class="help-block" ng-show="tarefa_form.safra.$dirty && tarefa_form.safra.$error.required">Informe a safra</p>
  </div>

  <div class="form-group" ng-class="{'has-error': tarefa_form.tipo.$invalid}"> <!-- Tipo de tarefa -->
    <ui-select ng-model="tarefa.task.tipo" theme="bootstrap" id="tipo" name="tipo" ng-change="tarefa.changeTipo()" required>
      <ui-select-match allow-clear="true" placeholder="Tipo">{{$select.selected.descricao | humanize}}</ui-select-match>
      <ui-select-choices repeat="tipo in tarefa.tipos | orderBy: 'descricao' | filter: $select.search">
        <span class="form-group" ng-bind-html="tipo.descricao | humanize | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
    <p class="help-block" ng-show="tarefa_form.tipo.$dirty && tarefa_form.tipo.$error.required">Informe o tipo</p>
  </div>

  <ng-include src="'tipo_stand.html'" ng-show="tarefa.isTipoStand()"></ng-include>
  <ng-include src="'tipo_produtividade.html'" ng-show="tarefa.isTipoProdutividade()"></ng-include>
  <ng-include src="'tipo_ocorrencia.html'" ng-show="tarefa.isTipoOcorrencia()"></ng-include>

  <div class="form-group" ng-class="{'has-error': tarefa_form.responsavel.$invalid}"> <!-- responsável -->
    <ui-select ng-model="tarefa.task.responsavel" theme="bootstrap" id="responsavel" name="responsavel" required>
      <ui-select-match allow-clear="true" placeholder="Responsável">{{$select.selected.nome_completo | capitalize}}</ui-select-match>
      <ui-select-choices repeat="responsavel in tarefa.usuarios | orderBy: 'nome_completo' | filter: $select.search">
        <span class="form-group" ng-bind-html="responsavel.nome_completo | capitalize | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
    <p class="help-block" ng-show="tarefa_form.responsavel.$dirty && tarefa_form.responsavel.$error.required">Informe o Responsável</p>
  </div>

  <div class="form-group"> <!-- encarregados -->
    <ui-select multiple ng-model="tarefa.task.encarregados" theme="bootstrap" id="encarregados" name="encarregados">
      <ui-select-match allow-clear="true" placeholder="Encarregados">{{$item.nome_completo | capitalize}}</ui-select-match>
      <ui-select-choices repeat="encarregado in tarefa.encarregados() | orderBy: 'nome_completo' | filter: $select.search">
        <span class="form-group" ng-bind-html="encarregado.nome_completo | capitalize | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </div>

  <!-- pontos -->
  <div class="form-group margin-pontos-tarefa" ng-repeat="marker in tarefa.task.markers track by $index"><!-- pontos da tarefa -->
    <div class="input-group">
      <span class="input-group-addon" id="basic-addon{$index + 1}}"><strong>{{$index + 1}}</strong></span>
      <input type="text" ng-model="marker.comentario" class="form-control"
             placeholder="Comentário..." aria-describedby="basic-addon{$index + 1}}"
             maxlength="255" >
      <span class="input-group-btn">
        <button type="button" class="btn btn-white" ng-click="tarefa.removeMarker(marker)">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </span>
    </div>
  </div>
  <br>
  <div class="form-group margin-data-inicial" ng-class="{'has-error': tarefa_form.data_inicial.$invalid}"><!-- data inicio -->
    <div class="input-group">
      <input type="text" class="form-control" readonly datepicker-options="tarefa.datePickerOptions" placeholder="Iniciar em"
        uib-datepicker-popup="{{tarefa.popupData.format}}" ng-model="tarefa.task.dataInicial"
        is-open="tarefa.popupData.openedDataInicial" show-button-bar="false"
        ng-change="tarefa.changeData('inicial')" id="data_inicial" name="data_inicial" required>
      <span class="input-group-btn">
        <button type="button" class="btn btn-default" ng-click="tarefa.openPopupData('openedDataInicial')">
          <i class="glyphicon glyphicon-calendar"></i>
        </button>
      </span>
    </div>
    <p class="help-block" ng-show="tarefa_form.data_inicial.$dirty && tarefa_form.data_inicial.$error.required">Informe a data inicial</p>
  </div>

  <div class="form-group" ng-class="{'has-error': tarefa_form.data_final.$invalid}"> <!-- data termino -->
    <div class="input-group">
      <input type="text" class="form-control" readonly datepicker-options="tarefa.datePickerOptions" placeholder="Finalizar em "
        uib-datepicker-popup="{{tarefa.popupData.format}}"
        ng-model="tarefa.task.dataFinal" is-open="tarefa.popupData.openedDataFinal" show-button-bar="false"
        ng-change="tarefa.changeData('final')" id="data_final" name="data_final" required>
      <span class="input-group-btn">
        <button type="button" class="btn btn-default" ng-click="tarefa.openPopupData('openedDataFinal')">
          <i class="glyphicon glyphicon-calendar"></i>
        </button>
      </span>
    </div>
    <p class="help-block" ng-show="tarefa_form.data_final.$dirty && tarefa_form.data_final.$error.required">Informe a data final</p>
  </div>

  <div class="form-group"> <!-- detalhamento -->
    <textarea class="form-control" ng-model="tarefa.task.observacao" id="observacao"
              placeholder="Detalhamento da tarefa" name="observacao">
    </textarea>
  </div>

  <div class="panel panel-default" ng-show="!tarefa.task.id">
    <div class="panel-heading">
      <div class="checkbox m-n">
        <label>
          <input type="checkbox" ng-model="tarefa.repeticao">Repetição
        </label>
      </div>
    </div>
    <div class="panel-body" ng-if="tarefa.repeticao">
      <div class="checkbox">
        <label>
          <input type="checkbox" ng-model="tarefa.customRepeatingTasks">
          Especificar tipos e datas das tarefas repetidas
        </label>
      </div>
      <div class="form-group" ng-show="!tarefa.customRepeatingTasks">
        <input class="form-control"
               placeholder="Intervalo (dias)"
               ng-model="tarefa.task.interval"
               type="number"
               id="interval"
               name="interval"
               ng-required="!!tarefa.task.quantity && !tarefa.customRepeatingTasks"
               min="0">
      </div>
      <div class="form-group">
        <input class="form-control"
               placeholder="Quantidade"
               ng-model="tarefa.task.quantity"
               type="number"
               id="quantity"
               name="quantity"
               ng-required="!!tarefa.task.interval || tarefa.customRepeatingTasks"
               ng-change="tarefa.setRepeatingAmount(tarefa.task.quantity)"
               min="0">
      </div>
      <div class="form-group" ng-if="tarefa.repeticao && tarefa.task.interval && tarefa.task.quantity">
        Será gerado uma nova tarefa a cada
        <ng-pluralize count="tarefa.task.interval" when="{'0': '', 'one': 'dia', 'other': '{{tarefa.task.interval}} dias'}">
        </ng-pluralize>
        <ng-pluralize count="tarefa.task.quantity" when="{'0': '', 'one': ' uma única vez', 'other': ' por {{tarefa.task.quantity}} vezes'}">
        </ng-pluralize>
      </div>
    </div>
  </div>

  <div class="panel panel-default" ng-if="tarefa.repeticao && tarefa.customRepeatingTasks">
    <div class="panel-heading">
      <h3 class="panel-title">Tipos e datas das repetições</h3>
    </div>
    <div class="panel-body" ng-repeat-start="repeatingTask in tarefa.repeatingTasks track by $index">
      <label class="control-label">Tarefa #{{$index + 2}}</label>
      <div class="form-group">
        <div class="input-group">
          <input type="text" class="form-control" readonly datepicker-options="tarefa.datePickerOptions" placeholder="Data"
                 uib-datepicker-popup="{{tarefa.popupData.format}}" ng-model="repeatingTask.date"
                 is-open="repeatingTask.openCalendar" show-button-bar="false" required>
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="repeatingTask.openCalendar = true">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
      </div>
      <div class="form-group" ng-class="{'has-error': tarefa_form['tipo'+$index].$invalid}">
        <ui-select ng-model="repeatingTask.tipo" theme="bootstrap" name="tipo{{$index}}" required>
          <ui-select-match allow-clear="true" placeholder="Tipo">{{$select.selected.descricao | humanize}}</ui-select-match>
          <ui-select-choices repeat="tipo in tarefa.tipos | orderBy: 'descricao' | filter: $select.search">
            <span class="form-group" ng-bind-html="tipo.descricao | humanize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
        <p class="help-block" ng-show="tarefa_form['tipo'+$index].$dirty && tarefa_form['tipo'+$index].$error.required">Informe o tipo</p>
      </div>
    </div>
    <hr ng-repeat-end ng-show="$index + 1 < tarefa.task.quantity" class="no-margin">
  </div>

  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="checkbox m-n">
        <label>
          <input type="checkbox" ng-disabled="!!tarefa.task.id" ng-model="tarefa.task.padrao_embrapa" name="padraoEmbrapa">
          Padrão Embrapa
        </label>
      </div>
    </div>
    <div ng-show="tarefa.task.padrao_embrapa">
      <div class="panel-body" ng-show="(tarefa.task.glebas || []).length">
        <p ng-class="tarefa.isValidEmbrapaPontos() ? 'text-success' : 'text-muted'">
          <b>Pontos:</b>
          {{(tarefa.task.markers || []).length}} de {{tarefa.padraoEmbrapaPontos()}}
          <i class="fa fa-check" ng-show="tarefa.isValidEmbrapaPontos()"></i>
        </p>
        <p>
          A distribuição dos pontos deve ser 70% em bordadura e 30% no meio.
        </p>
      </div>
      <div class="panel-body" ng-show="!(tarefa.task.glebas || []).length">
        <p class="text-danger">Filtre os talhões para exibir a contagem de pontos.</p>
      </div>
    </div>
  </div>

  <p class="text-muted">Adicione o local da tarefa clicando no mapa<span class="text-danger">*</p></span>

  <div class="btn-group btn-group-justified">
    <div class="btn-group">
      <button class="btn btn-primary" type="submit"
              ng-disabled="tarefa_form.$invalid || !tarefa.isValidEmbrapaPontos()"
              ng-if="$root.permissions.tarefa.canManage"
              role="button">
        Salvar
      </button>
    </div>
    <div class="btn-group" ng-if="tarefa.task.id && $root.permissions.tarefa.canManage">
      <button class="btn btn-danger" type="button" role="button" ng-click="tarefa.deleteTask()">
        Excluir
      </button>
    </div>
  </div>

</form>

<context-menu visible="tarefa.openContextMenu" position="tarefa.rightClickPosition">
  <li>
    <a ng-click="tarefa.removeMarker(tarefa.markerToDelete)">
      <i class="fa fa-trash"></i>
      Apagar ponto
    </a>
  </li>
</context-menu>

<script type="text/ng-template" id="tipo_stand.html">
  <div class="form-group">
    <div class="input-group">
      <input type="number" class="form-control" ng-model="tarefa.task.parametros.distancia_entre_linhas" placeholder="Distância entre linhas"
             autocomplete="off" min="0.01">
      <span class="input-group-addon">metros</span>
    </div>
  </div>

  <div class="form-group">
    <div class="input-group">
      <input type="number" class="form-control" ng-model="tarefa.task.parametros.comprimento_linhas" placeholder="Comprimento das linhas"
             autocomplete="off" min="0.01">
      <span class="input-group-addon">metros</span>
    </div>
  </div>

  <div class="form-group">
    <div class="input-group width-100">
      <input type="number" class="form-control" ng-model="tarefa.task.parametros.quantidade_linhas" placeholder="Quantidade de linhas"
             autocomplete="off" pattern="\d+" min="1">
    </div>
  </div>
</script>

<script type="text/ng-template" id="tipo_produtividade.html">
  <div class="form-group">
    <div class="input-group">
      <input type="number" class="form-control" ng-model="tarefa.task.parametros.pms" placeholder="PMS"
             autocomplete="off" pattern="\d+" min="1">
      <span class="input-group-addon">gramas</span>
    </div>
  </div>

  <div class="form-group">
    <div class="input-group">
      <input type="number" class="form-control" ng-model="tarefa.task.parametros.fator_correcao" placeholder="Fator de correção"
             autocomplete="off" min="0.01">
      <span class="input-group-addon">%</span>
    </div>
  </div>

  <div class="form-group">
    <div class="input-group width-100">
      <input type="number" class="form-control" ng-model="tarefa.task.parametros.numero_amostras" placeholder="Número de amostras"
             autocomplete="off" pattern="\d+" min="1">
    </div>
  </div>
</script>

<script type="text/ng-template" id="tipo_ocorrencia.html">
  <div class="form-group">
    <div class="width-100 pragas">
      <div class="form-group no-margin">
        <ui-select ng-model="praga.selected" on-select="addPraga($item)" theme="bootstrap" id="pragas" name="pragas">
          <ui-select-match allow-clear="true" placeholder="Pesquisar pragas">{{$select.selected.descricao}}</ui-select-match>
          <ui-select-choices repeat="praga in pragas" refresh="searchPragas($select)" refresh-delay="300">
            <div ng-bind-html="praga.descricao | highlight: $select.search"></div>
          </ui-select-choices>
        </ui-select>
        <small class="help-block" ng-show="searchPraga.length && !loadingPragas && !pragas">
          Informe pelo menos 3 caracteres
        </small>
        <span class="input-group-addon no-border no-background" ng-show="loadingPragas">
          <i class="fa fa-spinner fa-spin"></i>
        </span>
        <span class="input-group-addon no-border no-background" ng-show="!loadingPragas && pragas.length === 0">
          Não encontrado
        </span>
      </div>
      <button type="button" class="btn btn-white" title="Ver todas as pragas" ng-click="tarefa.openPragasModal()">
        <i class="fa fa-external-link"></i>
      </button>
    </div>

    <div class="width-100" ng-model="tarefa.task.pragas">
      <div class="form-control tarefas-pragas" ng-repeat="praga in tarefa.task.pragas track by $index">
        <span class="pull-left">
          {{ praga.descricao | characters:30 }}
        </span>
        <span type="button" class="btn pull-right no-padding no-border" uib-tooltip="Remover praga" tooltip-placement="left" ng-click="removePraga($index)">
          <i class="fa fa-times fa-lg" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</script>

<script type="text/ng-template" id="cultivarSelection.html">
  <div class="modal-header">
    <h3 class="modal-title">Selecione uma cultivar para a atividade:</h3>
  </div>
  <div class="modal-body" style="min-height: 200px;">
    <ui-select ng-model="tempCultivares.selected" theme="bootstrap">
      <ui-select-match allow-clear="true" placeholder="Cultivar">{{$select.selected.descricao}}</ui-select-match>
      <ui-select-choices repeat="cultivar in tempCultivares.cultivares | orderBy: 'descricao' | filter: $select.search">
        <span class="form-group" ng-bind-html="cultivar.descricao | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" type="button" ng-click="$close(tempCultivares.selected)" ng-disabled="!tempCultivares.selected">
      Selecionar
    </button>
  </div>
</script>
